<template>
  <el-dialog :title="$t('mainCategoryProduct.add')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('mainCategoryProduct.category')" prop="mainCategoryId">
        <el-select v-model="form.mainCategoryId" :placeholder="$t('mainCategoryProduct.selectCategory')"
          style="width:100%">
          <el-option v-for="item in mainCategoryOptions" :key="item.mainCategoryId" :label="item.categoryName"
            :value="item.mainCategoryId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('mainCategoryProduct.productCode')" prop="productId">
        <el-input v-model="form.productId" :placeholder="$t('mainCategoryProduct.inputProductCode')">
        </el-input>
        <p class="form-tip">{{ $t('mainCategoryProduct.productCodeTip') }}</p>
      </el-form-item>
      <el-form-item :label="$t('mainCategoryProduct.startTime')" prop="startTime">
        <el-date-picker v-model="form.startTime" type="datetime"
          :placeholder="$t('mainCategoryProduct.selectStartTime')" value-format="yyyy-MM-dd HH:mm:ss"
          style="width:100%">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('mainCategoryProduct.endTime')" prop="endTime">
        <el-date-picker v-model="form.endTime" type="datetime" :placeholder="$t('mainCategoryProduct.selectEndTime')"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('mainCategoryProduct.sort')" prop="seq">
        <el-input v-model="form.seq" :placeholder="$t('mainCategoryProduct.inputSort')">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveMainCategoryProduct, queryMainCategory } from '@/api/admin/mainCategoryProduct/mainCategoryProductApi'

export default {
  name: 'AddMainCategoryProduct',
  data() {
    return {
      dialogVisible: false,
      mainCategoryOptions: [],
      form: {
        mainCategoryId: '',
        productId: '',
        startTime: '',
        endTime: '',
        seq: ''
      },
      rules: {
        mainCategoryId: [
          { required: true, message: this.$t('mainCategoryProduct.categoryRequired'), trigger: 'blur' }
        ],
        productId: [
          { required: true, message: this.$t('mainCategoryProduct.productCodeRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('mainCategoryProduct.productCodeMaxLength'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('mainCategoryProduct.startTimeRequired'), trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: this.$t('mainCategoryProduct.endTimeRequired'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('mainCategoryProduct.sortRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('mainCategoryProduct.sortMustNumber'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.getMainCategoryList()
    },
    async getMainCategoryList() {
      try {
        const res = await queryMainCategory({ page: 1, row: 100 })
        this.mainCategoryOptions = res.data
      } catch (error) {
        console.error('获取分类列表失败:', error)
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveMainCategoryProduct(this.form)
            this.$message.success(this.$t('mainCategoryProduct.addSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('添加失败:', error)
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.form-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}
</style>